import {Injectable} from "@angular/core";
import {ActionSheetController} from "ionic-angular";
import {Camera, CameraOptions} from "@ionic-native/camera";
import {Md5} from "ts-md5/dist/md5";
import {NoticeService} from "./notice-service";
import {File} from "@ionic-native/file";
import {FileTransfer, FileTransferObject, FileUploadOptions} from "@ionic-native/file-transfer";
import {Observable} from 'rxjs/Observable';
import { PhotoLibrary } from '@ionic-native/photo-library';
declare var window;

@Injectable()
export class ImageService {

  // 参考：https://github.com/driftyco/ionic-native/blob/master/src/plugins/camera.ts
  // 调用相机时传入的参数
  private cameraOpt: CameraOptions = {
    quality: 50,
    destinationType: this.camera.DestinationType.FILE_URI,
    sourceType: this.camera.PictureSourceType.CAMERA,
    encodingType: this.camera.EncodingType.JPEG,
    mediaType: this.camera.MediaType.PICTURE,
    allowEdit: true,
    correctOrientation: true
  };

  upload: any = {
    url: 'http://v0.api.upyun.com/wanshidingdang',           //接收图片的url
    fileKey: 'image',  //接收图片时的key
    headers: {
      'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8' //不加入 发生错误！！
    },
    params: {},        //需要额外上传的参数
    success: (data) => {
    }, //图片上传成功后的回调
    error: (err) => {
    },   //图片上传失败后的回调
    listen: (data) => {
    }   //监听上传过程
  };

  fileTrans: FileTransferObject;

  constructor(private actionSheetCtrl: ActionSheetController,
              private noticeSer: NoticeService,
              public camera: Camera,
              public  transfer: FileTransfer,
              private photoLibrary: PhotoLibrary,
              private file: File) {

    this.cameraOpt = {
      quality: 50,
      destinationType: this.camera.DestinationType.FILE_URI,
      sourceType:this.camera.PictureSourceType.CAMERA,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      allowEdit: false,
      correctOrientation: true
    }

  }

  /**
   * 手机上传图片ActionSheets
   * @param {boolean} isMultiPicker
   * @param {number} maxImagesCount
   */
  showPicActionSheet(isMultiPicker: boolean = false, maxImagesCount: number = 6) {
    let actionSheet = this.actionSheetCtrl.create({
      title: '选择',
      buttons: [
        {
          text: '拍照',
          handler: () => {
            this.startCamera();
          }
        },
        {
          text: '从手机相册选择',
          handler: () => {
            if (!isMultiPicker) {
              this.singleImagePicker();
            } else {
              this.multiImagePicker(maxImagesCount);
            }
          }
        },
        {
          text: '取消',
          role: 'cancel',
          handler: () => {

          }
        }
      ]
    });
    actionSheet.present();
  }

  /**
   * 手机单图选择上传
   */
  public singleImagePicker() {
    // 调用相册时传入的参数
    const mediaSinglePickerOpt = {
      selectMode: 101,            // 101=picker image and video , 100=image , 102=video
      maxSelectCount: 1,          // default 40 (Optional)
      maxSelectSize: 188743680,   // 188743680=180M (Optional)
    };

    let fpath = '';
    let ts = this;
    window.MediaPicker.getMedias(mediaSinglePickerOpt, function (medias) {
      console.log(medias);
      if (medias.length) {
        //medias [{mediaType: "image", path:'/storage/emulated/0/DCIM/Camera/2017.jpg', uri:"android retrun uri,ios retrun URL" size: 21993}]
        fpath = medias[0].uri;
        // ts.uploadImg(fpath);
        ts.compressImage(medias[0])
      } else {
        console.log('user cancel');
        return;
      }

    }, function (e) {
      console.error(e);
    })
  }

  /**
   * 压缩图片
   * @param resultMedias
   */
  public compressImage(resultMedia: any) {
    let ts = this;


      if (resultMedia.size > 1048576) {
        resultMedia.quality = 60;
        window.MediaPicker.compressImage(resultMedia, function (compressData) {
          //user compressData.path upload compress img
          // console.log(compressData.path);
          ts.uploadImg(compressData.path);
        }, function (e) {
          console.log(e)
        });
      } else {
        ts.uploadImg(resultMedia.uri);
      }

    /*
    for (let i = 0; i < resultMedias.length; i++) {

      if (resultMedias[i].size > 1048576) {
        resultMedias[i].quality = 60;
        window.MediaPicker.compressImage(resultMedias[i], function (compressData) {
          //user compressData.path upload compress img
          console.log(compressData.path);
          ts.uploadImg(compressData.path);
        }, function (e) {
          console.log(e)
        });
      } else {
        ts.uploadImg(resultMedias[i].uri);
      }
    }
    */
  }







  /**
   * 手机多图选择上传
   * @param maximumImagesCount 最多可选择的图片数量
   */
  public multiImagePicker(maxCount) {

    function uploadSequenceSubscriber(observer) {
      let ts = this;
      let timeoutId;
      function getSeqArr() {
        let mediaMultiPickerOpt = {
          selectMode: 101,                            // 101=picker image and video , 100=image , 102=video
          maxSelectCount: maxCount,                          // default 40 (Optional) // @param=maximumImagesCount
          maxSelectSize: 188743680,                   // 188743680=180M (Optional)
        };
        window.MediaPicker.getMedias(mediaMultiPickerOpt, function (medias) {
          if (medias.length) {

            doUploadSequence(medias,0);

          } else {
            console.log('user cancel');
          }

        }, function (e) {
          console.error(e);
        })
      }

      function doUploadSequence(seq, idx) {
        // uploadToUpyun(medias[idx].uri);

        timeoutId = setTimeout(() => {
          observer.next(seq[idx]);
          if (idx === seq.length - 1) {
            observer.complete();
          } else {
            doUploadSequence(seq, ++idx);
          }
        }, 1000);
      }
      getSeqArr();
      // Unsubscribe should clear the timeout to stop execution
      return {
        unsubscribe() {
          clearTimeout(timeoutId);
        }
      };
    }

    let ts = this;

    console.log('手机多图选择上传', maxCount);

    const sequence = new Observable(uploadSequenceSubscriber);

    sequence.subscribe({
      next(num: any) {
        console.log('seq: ' + num.uri);
        ts.compressImage(num)
      },

      complete() {
        console.log('Finished sequence');
      },

    });


  }

  /**
   * 启动拍照功能
   */
  private startCamera() {
    this.camera.getPicture(this.cameraOpt).then((imageData) => {
      console.log(imageData);
      this.uploadImg(imageData);
    }, (err) => {
      this.noticeSer.showMsg('ERROR:' + err);  // 错误: 无法使用拍照功能！
    });
  }

  /**
   * 上传头像到又拍云
   * @param {string} path
   */

  /**
   * 长安保存图片到本地，相册的权限 及路径要改
   * @param {string} imgUrl
   */

  saveImageToLib(imgUrl: string) {
 /*  */ let album = "OVERDOSE";
    this.noticeSer.showLoading();
    this.photoLibrary.requestAuthorization().then(() => {
      this.photoLibrary.saveImage(imgUrl, album, ).then((success) => {
          console.log('保存成功');
          this.noticeSer.dismissLoading();
          this.noticeSer.showMsg('保存成功');
        },
        (err) => {
          this.noticeSer.dismissLoading();
          this.noticeSer.showMsg('保存失败');
        }).catch(err => console.log('error!????'));
    })
      .catch(err => console.log('permissions weren\'t granted'));

    /**
     this.getBase64ImageFromURL(imgUrl).subscribe(base64data => {
          console.log(base64data);
          let base64Image = 'data:image/jpg;base64,'+base64data;
          this.base64ToGallery.base64ToGallery(base64Image, { prefix: '_img', mediaScanner: true }).then(
            res => console.log('Saved image to gallery ', res),
            err => console.log('Error saving image to gallery ', err)
          );
        });
     **/
  }


  showSavePicActionSheet(imageUrl: string) {
    let actionSheet = this.actionSheetCtrl.create({
      // title: '选择',
      buttons: [
        {
          text: '保存图片',
          handler: () => {
            this.saveImageToLib(imageUrl);
          }
        },
        {
          text: '取消',
          role: 'cancel',
          handler: () => {

          }
        }
      ]
    });
    actionSheet.present();
  }


  // 上传图片
  uploadImg(path: string) {
    if (!path) {
      return;
    }
    this.fileTrans = this.transfer.create();

    let time = new Date().getTime();
    let policy = this.getPolicy(time);

    let signature = this.getBodySignature(policy);
    let options: FileUploadOptions = {
      fileKey: 'file',
      fileName: 'name.jpg',  // 文件类型
      headers: {},
      params: {
        'file': 'ddd.jpg',
        'policy': policy,
        'signature': signature
      }    // 如果要传参数，写这里
    };

    // loading
    /*
    this.fileTrans.onProgress((event: ProgressEvent) => {
      const num = Math.floor(event.loaded / event.total * 100);
      if (event.lengthComputable) {
        // this.noticeSer.loading.setContent('图片上传中：' + num + '%');
        this.upload.listen({'url': '/andriod/' + time + '.jpg', 'progress': num});
      }
    });
    */

    // console.log(options);
    this.noticeSer.showLoading();
    this.fileTrans.onProgress((event: ProgressEvent) => {
      const num = Math.floor(event.loaded / event.total * 100);
      if (event.lengthComputable) {
        this.noticeSer.loading.setContent('图片上传中：' + num + '%');
      }else
      {
        this.noticeSer.dismissLoading();
      }
    });

    // upload
    this.fileTrans.upload(path, this.upload.url, options)
      .then((data) => {

        console.log(data);
        if (this.upload.success) {
          this.upload.success(JSON.parse(data.response));
        }

      }, (err) => {

        console.log(err);
        if (this.upload.error) {
          this.upload.error(err);
        } else {
          this.noticeSer.showToast('错误：上传失败！');
        }
      });
  }

  /**
   * 停止上传
   */
  stopUpload() {

  }

  /**
   * 又拍云 Policy
   * @return {string}
   */
  private getPolicy(time) {

    let params: any = {
      'bucket': 'wanshidingdang',
      'save-key': '/andriod/' + time + '.jpg',
      'service': 'wanshidingdang',
      'expiration': time + 24 * 60 * 60
    };
    let policy = JSON.stringify(params);
    policy = Base64.encode(policy);
    return policy.toString();
  }

  /**
   * 又拍云 BodySignature
   * @param {string} policy
   * @return {string}
   */
  private getBodySignature(policy: string) {
    let signature: string = Md5.hashStr(policy + '&p04SeyUgHnHnsDLk8qkhTrBsltQ=').toString();
    return signature;

  }

  /**
   * base64转blob
   * @param urlData
   * @param fileType
   * @return {Blob}
   */
  private toBlob(urlData, fileType) {
    var bytes = window.atob(urlData),
      n = bytes.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bytes.charCodeAt(n);
    }
    return new Blob([u8arr], {type: fileType});
  }

}

class Base64 {
  // private property
  static _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

  // public method for encoding
  public static encode(input) {
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;
    input = this.utf8_encode(input);
    while (i < input.length) {
      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);
      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;
      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }
      output = output +
        this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
        this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
    }
    return output;
  }

  // private method for UTF-8 encoding
  public static utf8_encode(string) {
    string = string.replace(/\r\n/g, "\n");
    var utftext = "";
    for (var n = 0; n < string.length; n++) {
      var c = string.charCodeAt(n);
      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if ((c > 127) && (c < 2048)) {
        utftext += String.fromCharCode((c >> 6) | 192);
        utftext += String.fromCharCode((c & 63) | 128);
      } else {
        utftext += String.fromCharCode((c >> 12) | 224);
        utftext += String.fromCharCode(((c >> 6) & 63) | 128);
        utftext += String.fromCharCode((c & 63) | 128);
      }
    }
    return utftext;
  }

}


// function uploadSequenceSubscriber(observer) {
//   // const seq = [1, 2, 3];
//   let timeoutId;
//
//   function getSeqArr() {
//     let mediaMultiPickerOpt = {
//       selectMode: 101,                            // 101=picker image and video , 100=image , 102=video
//       maxSelectCount: 6,                          // default 40 (Optional) // @param=maximumImagesCount
//       maxSelectSize: 188743680,                   // 188743680=180M (Optional)
//     };
//     window.MediaPicker.getMedias(mediaMultiPickerOpt, function (medias) {
//       if (medias.length) {
//
//         doUploadSequence(medias,0);
//
//       } else {
//         console.log('user cancel');
//       }
//
//     }, function (e) {
//       console.error(e);
//     })
//   }
//
//   function doUploadSequence(seq, idx) {
//     // uploadToUpyun(medias[idx].uri);
//
//     timeoutId = setTimeout(() => {
//       observer.next(seq[idx]);
//       if (idx === seq.length - 1) {
//         observer.complete();
//       } else {
//         doUploadSequence(seq, ++idx);
//       }
//     }, 1000);
//   }
//   getSeqArr();
//
//
//
//
//   // Will run through an array of numbers, emitting one value
//   // per second until it gets to the end of the array.
//   /*
//   function doSequence(arr, idx) {
//     timeoutId = setTimeout(() => {
//       observer.next(arr[idx]);
//       if (idx === arr.length - 1) {
//         observer.complete();
//       } else {
//         doSequence(arr, ++idx);
//       }
//     }, 1000);
//   }
//   doSequence(seq, 0);
//   */
//   // Unsubscribe should clear the timeout to stop execution
//   return {
//     unsubscribe() {
//       clearTimeout(timeoutId);
//     }
//   };
// }



// WEBPACK FOOTER //
// ./src/providers/api-service/image-service.ts